<div class="discount-banner" [@slideDown]="isVisible ? 'visible' : 'hidden'">

    <div class="banner-content">
        @if (!isSmallScreen$()){
        <div class="banner-icon">
            <mat-icon style="color: #FF5722;">local_offer</mat-icon>
        </div>
        }

        <div class="banner-text">
            <div class="banner-title">{{ discountText }}</div>
            <div class="banner-subtitle">
                <strong>{{ code }}</strong> - bis zum {{ expiresAt | date:'dd.MM.yyyy' }} gültig
            </div>
        </div>

        <div class="banner-actions">
            <button mat-button color="primary" (click)="onCopyCode()" matTooltip="Code in Zwischenablage kopieren">
                <mat-icon>content_copy</mat-icon>
                Kopieren
            </button>

            <button mat-icon-button class="close-button" (click)="onClose()" matTooltip="Banner schließen">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>